<template>
  <footer class="footer">
    <div class="footer__container container">
      <ul class="footer__columns list-reset">
        <li class="footer__column column__left">
          <div class="footer__logo-wrapper">
            <router-link class="footer__logo-link" to="/">
              <img
                class="footer__logo logo"
                src="@/assets/img/logo.png"
                alt="SymbioWay"
              />
            </router-link>
            <p v-if="$route.name === 'main'" class="footer__slogan p-reset">
              Регистрируйтесь, приводите&nbsp;клиентов
              и&nbsp;получайте&nbsp;доход
            </p>
            <p v-else class="footer__slogan not-main p-reset">
              Реферальная программа
            </p>
          </div>
          <p class="footer__contact p-reset">
            По всем вопросам обращайтесь:
            <a
              class="footer__contact-link link-reset"
              href="mailto:deal@symbioway.ru"
              >deal@symbioway.ru</a
            >
          </p>
        </li>

        <li class="footer__column column__center">
          <ul class="footer__organizations-list list-reset">
            <li class="footer__organizations-item">
              <a
                href="https://www.symbioway.ru/"
                target="_blank"
                class="footer__organizations-link link-reset"
              >
                SymbioWay
              </a>
              <p class="footer__organizations-desc p-reset">
                Подбор IT-специалистов на&nbsp;постоянную&nbsp;работу
              </p>
            </li>
            <li class="footer__organizations-item">
              <a
                href="https://www.sw-development.ru"
                target="_blank"
                class="footer__organizations-link link-reset"
              >
                SW Development
              </a>
              <p class="footer__organizations-desc p-reset">
                Предоставление услуг IT-специалистов
                на&nbsp;почасовой&nbsp;основе
              </p>
            </li>
          </ul>
        </li>

        <li class="footer__column column__right">
          <FooterNav />
        </li>
      </ul>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  padding: 50px 0;
  background-color: #1d1d1d;
}

.footer__columns {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.column__left {
  flex: 0 0 35%;
}

.column__center {
  flex: 0 0 35%;
}

.column__right {
  flex: 0 0 20%;
  justify-self: flex-end;
}

.footer__column {
  color: var(--white);
}

.footer__column:not(:last-child) {
  margin-right: 20px;
}

.footer__logo-wrapper {
  display: flex;
  align-items: flex-start;
  margin-bottom: 60px;
  align-items: center;
}

.footer__logo-link {
  display: block;
  width: 64px;
  height: 58px;
  margin-right: 10px;
}

.footer__logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.footer__slogan {
  margin-bottom: -4px;
  font-size: 14px;
  line-height: 120%;
  max-width: 200px;
}

.footer__slogan.not-main {
  text-transform: uppercase;
  line-height: 200%;
}

.footer__contact {
  font-size: 18px;
}

.footer__contact-link {
  display: inline-block;
  position: relative;
  margin-top: 5px;
  font-size: 20px;
  color: var(--white);
  transition: color 0.2s linear;
}

.footer__contact-link:hover:not(:active) {
  color: var(--main);
}

.footer__contact-link:active {
  color: var(--main-active);
}

.footer__contact-link:focus-within {
  color: var(--main-hover);
}

.footer__organizations-item:not(:last-child) {
  margin-bottom: 30px;
}

.footer__organizations-link {
  position: relative;
  display: inline-block;
  margin-bottom: 15px;
  color: var(--main);
}

.footer__organizations-link::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 0;
  right: 0;
  height: 3px;
  background-color: transparent;
  transition: background-color 0.2s linear;
}

.footer__organizations-link:hover:not(:active)::after {
  background-color: var(--main);
}

.footer__organizations-link:active::after {
  background-color: var(--main-active);
}

.footer__organizations-link:focus-within:not(:active):after {
  background-color: var(--main-hover);
}

.footer__organizations-desc {
  font-size: 16px;
}

@media (max-width: 1160px) {
  .footer__column:not(:last-child) {
    margin-right: 0;
  }

  .column__left {
    flex: 1 0 80%;
    margin-bottom: 70px;
  }

  .footer__logo-wrapper {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 30px;
  }

  .footer__logo {
    margin-bottom: 20px;
  }

  .column__center {
    flex: 0 0 40%;
    order: 3;
  }

  .column__right {
    margin-left: auto;
    flex: 1 0 20%;
    justify-self: flex-end;
    order: 2;
  }
}

@media (max-width: 769px) {
  .column__left {
    flex: 1 0 100%;
    margin-bottom: 70px;
  }

  .column__center {
    flex: 0 0 40%;
    order: 2;
  }

  .column__right {
    margin-left: auto;
    flex: 1 0 20%;
    justify-self: flex-end;
    order: 3;
  }
}

@media (max-width: 600px) {
  .footer__columns {
    flex-direction: column;
  }

  .footer__column:not(:last-child) {
    margin-bottom: 30px;
  }

  .column__left {
    display: flex;
    flex-wrap: wrap;
    flex: 0 0 auto;
    margin-bottom: 0;
  }

  .footer__logo-wrapper {
    flex-direction: row;
    align-items: center;
    margin-bottom: 30px;
  }

  .footer__logo {
    margin-bottom: 0;
  }
  .footer__contact {
    flex: 1 0 100%;
    font-size: 16px;
  }

  .footer__contact-link {
    font-size: 16px;
  }

  .column__center {
    flex: 0 0 auto;
  }

  .column__right {
    flex: 0 0 auto;
    margin-left: 0;
  }
}
</style>

<script>
import FooterNav from '@/components/FooterNav.vue'
export default {
  components: { FooterNav }
}
</script>
